import { addCreditCardPayment } from "queries/customer";
import React from "react";
import ReactMarkdown from "react-markdown";
import { useAppSelector } from "reduxUtils/hook";
import { visitLink } from "utils/htmlLinks/visitLink";
import { jwtClient } from "utils/jwtClient";

import content from "./static/content.json";
const { cardButtonLabel, cardMethodInfoText } = content;

export const CreditCardPaymentForm: React.FC = () => {
  const { accountNumber, nativeRenderMode } = useAppSelector(
    (store) => store.currentAccount,
  );

  /** For detail on windcave transactions see doc/architecture/decisions/0010-processing-credit-card-payments.md */
  const handleAddCardClicked = async () => {
    const response: AddCardPaymentResponse = await addCreditCardPayment({
      accountIdentifier: accountNumber,
      jwtClient,
      redirectUrl: `${process.env.REACT_APP_PUBLIC_URL}/account/billing`,
    });

    const windCaveUrl = response.attributes.url;
    if (windCaveUrl && response.id) {
      window.sessionStorage.setItem("windcaveTransactionId", response.id);

      if (nativeRenderMode) {
        visitLink({
          url: windCaveUrl,
        });
      } else {
        window.location.href = windCaveUrl;
      }
    }
  };

  return (
    <div className="payment-method-container">
      <ReactMarkdown>{cardMethodInfoText}</ReactMarkdown>
      <button
        className="button button_primary--black button_primary--small button--expanded"
        onClick={handleAddCardClicked}
      >
        {cardButtonLabel}
      </button>
    </div>
  );
};
